export const reportError = error => {
  // TODO: send data to DataDog
  // eslint-disable-next-line no-console
  console.error(error);
};
